import * as React from "react";
import { SVGProps } from "react";
export const FlagIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <mask
            id="mask0_14754_239"
            style={{
                maskType: "alpha",
            }}
            maskUnits="userSpaceOnUse"
            x={0}
            y={0}
            width={20}
            height={20}
        >
            <rect width={20} height={20} fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_14754_239)">
            <path
                d="M5.83335 10.8333V17.5C5.83335 17.7361 5.75349 17.934 5.59377 18.0937C5.43405 18.2535 5.23613 18.3333 5.00002 18.3333C4.76391 18.3333 4.56599 18.2535 4.40627 18.0937C4.24655 17.934 4.16669 17.7361 4.16669 17.5V3.33333C4.16669 3.09722 4.24655 2.89931 4.40627 2.73958C4.56599 2.57986 4.76391 2.5 5.00002 2.5H16.2709C16.4236 2.5 16.559 2.53472 16.6771 2.60417C16.7952 2.67361 16.8889 2.76389 16.9584 2.875C17.0278 2.98611 17.0729 3.10764 17.0938 3.23958C17.1146 3.37153 17.0972 3.50694 17.0417 3.64583L15.8334 6.66667L17.0417 9.6875C17.0972 9.82639 17.1146 9.96181 17.0938 10.0938C17.0729 10.2257 17.0278 10.3472 16.9584 10.4583C16.8889 10.5694 16.7952 10.6597 16.6771 10.7292C16.559 10.7986 16.4236 10.8333 16.2709 10.8333H5.83335ZM5.83335 9.16667H15.0417L14.2917 7.29167C14.2084 7.09722 14.1667 6.88889 14.1667 6.66667C14.1667 6.44444 14.2084 6.23611 14.2917 6.04167L15.0417 4.16667H5.83335V9.16667Z"
                fill="currentColor"
            />
        </g>
    </svg>
);
FlagIcon.displayName = "FlagIcon";
